import { IWorkLogUpdate } from "@wingspanhq/payments/dist/interfaces";
import { updateWorkLog } from "../../../services/workLog";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import { QUERY_WORK_LOG } from "../queries/useQueryWorkLog";
import { QUERY_WORK_LOGS } from "../queries/useQueryWorkLogs";

export const useMutationUpdateWorkLog = () =>
  useWSMutation<
    Awaited<ReturnType<typeof updateWorkLog>>,
    WSServiceError,
    { workLogId: string; request: IWorkLogUpdate }
  >(({ workLogId, request }) => updateWorkLog(workLogId, request), {
    dependencies: [QUERY_WORK_LOG, QUERY_WORK_LOGS]
  });
